// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-drawer[data-v-0e4a2bb2] .el-drawer .el-drawer__title {\n  font-size: 0.53333rem;\n}\n.box-drawer .row-header[data-v-0e4a2bb2] {\n  font-size: 0.42667rem;\n  font-weight: 600;\n}\n.box-drawer .row-desc[data-v-0e4a2bb2] {\n  margin: 0.26667rem 0;\n}\n.box-drawer .row-option[data-v-0e4a2bb2] {\n  font-size: 0.32rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
